/*
 * Режим сборки фронтенда: один и тот же исходник `erp/` собирается в два
 * разных сайта Cloudflare Pages.
 *
 *   VITE_SITE_MODE=marketing → onboardix.com  — публичный сайт продукта.
 *   VITE_SITE_MODE=erp       → erp.onboardix.com — рабочая система.
 *
 * Источник истины — переменная сборки, а не имя хоста: одна и та же выкладка
 * может открываться по нескольким адресам (preview-домены Cloudflare), и
 * угадывание по хосту дало бы разное поведение у одного бандла. Проверка
 * хоста оставлена страховкой ровно для двух боевых имён: если переменную
 * забыли задать в проекте `onboardix-site`, посетитель увидит сайт, а не
 * экран входа.
 */

import { ERP_ORIGIN, MARKETING_ORIGIN } from './siteMeta'

const MARKETING_HOSTS = new Set(['onboardix.com', 'www.onboardix.com'])

export const SITE_MODE_MARKETING = 'marketing'
export const SITE_MODE_ERP = 'erp'

/**
 * Чистая функция — тестируется без подмены window и import.meta.
 * @param {{ envMode?: string, hostname?: string }} input
 * @returns {'marketing' | 'erp'}
 */
export function resolveSiteMode({ envMode, hostname } = {}) {
    const normalized = String(envMode ?? '').trim().toLowerCase()
    if (normalized === SITE_MODE_MARKETING) return SITE_MODE_MARKETING
    if (normalized === SITE_MODE_ERP) return SITE_MODE_ERP
    if (hostname && MARKETING_HOSTS.has(String(hostname).trim().toLowerCase())) {
        return SITE_MODE_MARKETING
    }
    return SITE_MODE_ERP
}

export const SITE_MODE = resolveSiteMode({
    envMode: import.meta.env?.VITE_SITE_MODE,
    hostname: typeof window !== 'undefined' ? window.location?.hostname : undefined,
})

export const isMarketingSite = SITE_MODE === SITE_MODE_MARKETING

/*
 * Публичный сайт живёт на основном домене, рабочая система — на поддомене.
 * Адреса берём из общего модуля, а не объявляем заново: canonical публичного
 * сайта собирают ДВЕ стороны — плагин сборки и клиент при переходе с
 * юридической страницы. Разъехавшись, они дали бы в выдаче один адрес, а во
 * вкладке другой. Импорт односторонний: `siteMeta.js` не знает про
 * `import.meta` и потому читается и Node на сборке, и браузером.
 */
export const ERP_APP_URL = ERP_ORIGIN
export const MARKETING_SITE_URL = MARKETING_ORIGIN
export const CONTACT_EMAIL = 'privacy@onboardix.com'
